export enum UserRole {
    Coordinator = 'coordinator',
    User = 'user',
    Manager = 'manager',
    Admin = 'admin',
    SuperUser = 'super_user',
    SuperEngineer = 'super_engineer',
    SuperUserReadonly = 'super_user_readonly',
}

export interface User {
    autoPauseWeeklySummaryEmails: boolean;
    enableWeeklySummaryEmails: boolean;
    email: string;
    firstName: string;
    isActive: boolean;
    id: string;
    lastName: string;
    phoneNumber: string | undefined;
    roles: UserRole[];
    tenantId: string;
    tenantName: string;
    title: string | undefined;
    isImpersonated: boolean;
    permissionedTenantIds: string[];
    accessibleTenantIds?: string[];
    mfaEnabled: boolean;
}
